import { getConfigBaseUrl } from '../../services/apiService';
import gql from 'graphql-tag';

export const getInventoryDataQuery = () => `${getConfigBaseUrl()}/v1/bny/inventory/positions`;

export const getHoldInventoryDataQuery = (fromSubstitution?: boolean) =>
  `${getConfigBaseUrl()}/v1/bny/inventory/hold${fromSubstitution ? '?fromSubstitution=true' : ''}`;

export const getDeleteSecurityQuery = (basketId: string, version: number, itemId: number) =>
  `${getConfigBaseUrl()}/v1/bny/basket/${basketId}/${version}/items/${itemId}`;

export const getDeleteBasketQuery = (basketId: string, version: number) =>
  `${getConfigBaseUrl()}/v1/bny/basket/${basketId}/${version}/cancel`;

export const getSaveBasketQuery = (basketId: string, version: number, fromOrderEntry: boolean) =>
  `${getConfigBaseUrl()}/v1/bny/basket/${basketId}/${version}/${fromOrderEntry ? 'submitbasket' : 'submit'}`;

export const getAllBasketsQuery = () => gql`
  query {
    allAvailableBaskets {
      basketId
      basketName
      id
      version
      clientId
      status
      orderId
      tenantId
      createdByUser
      createdDate
      modifiedByUser
      modifiedDate
    }
  }
`;

export const getClientsAndFundsQuery = () => gql`
  query {
    allClients {
      id
      clientId
      shortCode
      shortName
      longName
      tenantId
      groupId
      allowNonBusinessDay
      basketRouting
      funds {
        id
        fundId
        accountId
        shortCode
        shortName
        longName
      }
      counterParties {
        id
        counterPartyId
        code
        shortName
        longName
      }
    }
  }
`;

export const getBasketWithIdQuery = (
  basketId: string,
  version: number,
  currency: string = 'USD',
) => gql`
  query {
    basket(basketId: "${basketId}", version:${version}, currency: "${currency}") {
      id
      basketId
      basketName
      version
      clientId
      status
      orderId
      tenantId
      createdByUser
      createdDate
      basketItemDetails {
      basketItems {
        id
        basketItemId
        fundId
        securityName
        version
        security
        bbgTickerExch
        isin
        sedol
        quantity
        substitutionQuantity
        divRate
        exDate
        recordDate
        price
        fxRate
        tradeId
        eligible
        createdByUser
        createdDate
        inputCurrency
        swapCurrency
        notional
        settlementDate
        tradeDate
        }
      }
    }
  }
`;
